import { createAsyncThunk } from '@reduxjs/toolkit';
import { getServiceLevelDashboardUseCase } from 'modules/outbound/serviceLevel/application/GetServiceLevelDashboardUseCase';

const getServiceLevelDashboard = createAsyncThunk(
  'serviceLevel/getServiceLevelDashboard',
  () => getServiceLevelDashboardUseCase.execute()
);

export { getServiceLevelDashboard };
